import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from 'core/ui/Button';
import Spinner from 'core/components/Spinner';
import { StyledFooterButton } from './forethoughtButtonStyles';

class ForethoughtButton extends Component {
	state = { isLoading: false };

	handleClick = (e) => {
		e.preventDefault();
		this.injectScript();
	};

	/**
	* Inject Forethought script manually
	* to give us control over how/when to load
	*/
	injectScript = () => {
		const _id = 'forethought_chat';

		// Avoid loading script twice
		// And flipping into loading mode when unecessary
		if (document.getElementById(_id)) {
			window.Forethought("widget", "open");
			return;
		}

		this.setState({ isLoading: true });

		const _inject = () => {
			const _name = window.cj.user.name ?? "";
			const _email = window.cj.user.email ?? "";

			const src = "https://solve-widget.forethought.ai/embed.js";
			const script = document.createElement('script');

			script.id = _id;
			script.async = true;
			script.src = src;
			script.type = "application/javascript";
			script.setAttribute('data-api-key', '02ae06b8-7201-4b60-aa0e-375a892af97f');
			script.setAttribute('data-ft-email', _email);
			script.setAttribute('data-ft-name', _name);
			script.setAttribute('data-ft-user', 'buyer');

			// this attribute will open the widget in
			// the expanded form  when the script is
			// injected
			script.setAttribute("full-screen", "true");

			if (document.head) {
				document.head.appendChild(script);
			}

			this.setState({ isLoading: false });
		};
		// 1. Load non-blocking with setTimeout
		// 2. Wrap call in `requestIdleCallback`, if available
		// 3. Then load the script
		setTimeout(() => {
			"requestIdleCallback" in window
				? requestIdleCallback(_inject, { timeout: 1000 })
				: _inject();
		}, 0);
	};

	render () {
		const {
			type,
			label
		} = this.props;

		const { isLoading } = this.state;

		if (type === "footer-button") {
			return (
				<StyledFooterButton onClick={this.handleClick}>
					{isLoading ? (<Spinner />) : label}
				</StyledFooterButton>
			);
		}

		return (
			<Button size={"lg"} style={{ padding: "0 64px" }} onClick={this.handleClick}>
				{isLoading ? (<Spinner />) : label}
			</Button>
		);
	}
}

ForethoughtButton.propTypes = {
	type: PropTypes.oneOf(['contact-cratejoy-button', 'footer-button']),
	label: PropTypes.string
};

ForethoughtButton.defaultProps = {
	type: 'contact-cratejoy-button',
	label: 'Contact Cratejoy'
};

export default ForethoughtButton;
